<!-- eslint-disable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text -->
<script setup>
import { ref } from 'vue';

const props = defineProps({
  variant: { type: String, default: 'inline' },
  showTooltip: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  active: { type: Boolean, default: false },
});

const emit = defineEmits(['click']);

const tooltipDismissed = ref(false);

const handleClick = () => {
  if (props.disabled || props.isLoading) return;
  tooltipDismissed.value = true;
  emit('click', { source: props.variant });
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text -->
  <div class="relative inline-flex">
    <button
      type="button"
      class="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-[13px] font-semibold transition-all disabled:cursor-not-allowed disabled:opacity-50"
      :class="
        active
          ? 'border-emerald-200 bg-emerald-50 text-emerald-800'
          : 'border-lais-primary bg-white text-lais-primary hover:bg-lais-primary-50'
      "
      :disabled="disabled || isLoading"
      @click="handleClick"
    >
      <span
        class="h-4 w-4"
        :class="[
          isLoading
            ? 'i-lucide-loader-circle animate-spin'
            : active
              ? 'i-lucide-check'
              : 'i-lucide-store',
        ]"
      />
      {{ active ? 'Na vitrine' : 'Adicionar à vitrine' }}
    </button>
    <span
      v-if="showTooltip && !tooltipDismissed"
      class="absolute -top-12 right-0 rounded-lais bg-lais-primary px-3 py-1.5 text-[11px] font-semibold text-white shadow-lais-card"
    >
      Novo · descubra como criar vitrines
    </span>
  </div>
</template>
